$(document).on('click', '.faqs-tab_item', function() {
  let title_handle = $(this).data('tab-title');
  console.log(title_handle);
  let parent = $(this).closest('.faqs-tabing');
  parent.find('.faqs-tab_item').removeClass('active');
  $(this).addClass('active');
  parent.find('.accordion').removeClass('active');
  parent.find('.faq_accordion-title').removeClass('active');
  parent.find('.accordion').each(function() {
    if ($(this).data('tab-faqs') == title_handle) {
      $(this).addClass('active');
    }
  });
  parent.find('.faq_accordion-title').each(function() {
    if ($(this).data('accordion-title') == title_handle) {
      $(this).addClass('active');
    }
  });
});
$(document).ready(function() {
  $('.faqs-tabing').each(function() {
    $(this).find('.faqs-tab_item').first().trigger('click');
  });
});

document.addEventListener('DOMContentLoaded', function () {
  var elem = document.querySelector('.ct-cstm-testimonial_slider');
  if (elem && typeof Flickity !== 'undefined') {
    new Flickity(elem, {
      cellAlign: 'left',
      contain: true,
      wrapAround: true,
      pageDots: false,
      prevNextButtons: true,
      groupCells: true
    });
  }
});


if(window.innerWidth < 750) {
$(document).ready(function () {
  $('.cstm-testimonial-item_wrp').on('click', function () {
    $(this).toggleClass('flipped');
  });
});
}

$(document).on('click', '.pdp_mute_unmute_btn', function () {

  const $btn = $(this);
  const $media = $btn.closest('.deferred-media');

  // Shopify video + HTML5 video dono handle karega
  const video = $media.find('video').get(0);

  if (!video) return;

  if (video.muted) {
      video.muted = false;
      $btn.addClass('is-unmuted');
  } else {
      video.muted = true;
      $btn.removeClass('is-unmuted');
  }
});




$(document).on('click', '.kit-use_tab', function(){
  var index = $(this).index();
  $('.kit-use_tab').removeClass('active');
  $(this).addClass('active');
  $('.kit-uses_media, .kit-uses_content').removeClass('active');
  $('.kit-uses_media').eq(index).addClass('active');
  $('.kit-uses_content').eq(index).addClass('active');
});


$(document).ready(function () {
  $('.ct-testimonials_section .testimonial__preview').on('click', function () {
    $(this).toggleClass('flipped');
  });
  $('.card_text_plus').on('click', function () {
    $('.ct_pdp_category_card').removeClass('active');
    $(this).parents('.ct_pdp_category_card').addClass('active');
  });
  $('.card_text_minus').on('click', function () {
    $(this).parents('.ct_pdp_category_card').removeClass('active');
  });
});

var sliders = document.querySelectorAll('.card_product_image_slider');
  if (sliders.length && typeof Flickity !== 'undefined') {
    sliders.forEach(function(slider){
      var flkty = new Flickity(slider,{
        cellAlign:'left',
        contain:true,
        wrapAround:true,
        pageDots:false,
        prevNextButtons:false,
        setGallerySize: false
      });
      var productCard = slider.closest('.ct-card_product');
      var thumbnails = productCard.querySelectorAll('.card_product_thumnail');
      thumbnails.forEach(function(thumb,index){
        thumb.addEventListener('click',function(){
          flkty.select(index);
          thumbnails.forEach(function(t){
            t.classList.remove('active');
          });
          thumb.classList.add('active');
        });
      });
      flkty.on('change', function(index){
        thumbnails.forEach(function(t){
          t.classList.remove('active');
        });
        if(thumbnails[index]){
          thumbnails[index].classList.add('active');
        }
      });
    });
  }